import { enCoreMessages } from './messages.en-core'
import { enCustomerMessages } from './messages.en-customer'

export const enMessages = {
  ...enCoreMessages,
  ...enCustomerMessages,
} as const
